var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import omit from 'lodash/omit';
import React, { forwardRef } from 'react';
import EdsTable from '@hedtech/react-design-system/core/es/Table';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = ((theme) => createStyles({
    root: {
        '& tbody td, & tbody th': {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'row'
            }
        },
        '& tbody td:before, & tbody th:before': {
            [theme.breakpoints.only('xs')]: {
                minWidth: '6rem',
                width: '6rem!important'
            },
            minWidth: '12rem',
            width: '12rem!important',
            wordBreak: 'normal'
        },
        '& td[data-fullwidth]::before': {
            minWidth: '0!important',
            width: '0!important'
        },
        '& th[data-actionmenu], td[data-actionmenu]': {
            textAlign: 'right'
        },
        '& thead > tr > th': {
            fontWeight: 'bold'
        }
    },
    tableContainer: {
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%'
    }
}));
const Table = (props, ref) => {
    const { breakpoint, classes, children, variant } = props, rest = __rest(props, ["breakpoint", "classes", "children", "variant"]);
    return (React.createElement("div", { className: classes.tableContainer },
        React.createElement(EdsTable, Object.assign({ classes: Object.assign({}, omit(classes, ['tableContainer'])), layout: breakpoint || variant ? {
                breakpoint: breakpoint ? breakpoint : '',
                variant: variant ? variant : ''
            } : undefined, ref: ref }, rest), children)));
};
const TableFRC = forwardRef(Table);
TableFRC.displayName = 'TableFRC';
export default withStyles(styles, { name: 'TableWS' })(TableFRC);
